<div class="loading-overlay">
  <div class="spinner"></div>
  <p>Loading, please wait...</p>
</div>
